var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"categoria-disciplina","rota-base":"/admin/categoria-disciplina","titulo-singular":"Categoria de Disciplina","campos-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }